import * as React from "react";
const SvgPrimaryView = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={14}
    fill="none"
    {...props}
  >
    <path
      stroke="#082B60"
      strokeWidth={1.25}
      d="M14.819 4.843C13.115 2.166 10.623.625 7.999.625c-1.313 0-2.589.383-3.754 1.099C3.08 2.446 2.033 3.5 1.178 4.843.441 6 .441 7.88 1.178 9.038c1.703 2.684 4.195 4.217 6.82 4.217 1.313 0 2.588-.383 3.753-1.098 1.165-.723 2.212-1.777 3.068-3.119.737-1.15.737-3.038 0-4.195Zm-6.82 5.08a2.975 2.975 0 0 1-2.98-2.979A2.975 2.975 0 0 1 8 3.965a2.975 2.975 0 0 1 2.978 2.979 2.975 2.975 0 0 1-2.979 2.979Z"
    />
  </svg>
);
export default SvgPrimaryView;
